var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, width: "450", persistent: "" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v(" Confirm Cancellation ")]),
          _c("v-card-text", [
            _vm._v(
              ' Cancel contract upload process for "' +
                _vm._s(_vm.selectedContract.file_name) +
                '"? '
            )
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "grey darken-1",
                    text: "",
                    disabled: _vm.loading
                  },
                  on: { click: _vm.close }
                },
                [_vm._v(" Close ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: _vm.loading,
                    loading: _vm.loading
                  },
                  on: { click: _vm.cancel }
                },
                [_vm._v(" Confirm ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }